/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessOffers.internal

import features.userBusinessOffers.models.UserBusinessOffersModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.userBusinessOffers.internal.UserBusinessOffersUseCase.Params

internal class UserBusinessOffersUseCase : AsyncUseCase<UserBusinessOffersModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val businessId: String
    )

    private val userBusinessOffersService: UserBusinessOffersService = UserBusinessOffersServiceImpl()

    override suspend fun run(params: Params): Result<UserBusinessOffersModel> {
        return userBusinessOffersService.getUserBusinessOffers(
            overrideHeaders = params.overrideHeaders,
            businessId = params.businessId
        )
    }
}
